module.exports = __webpack_public_path__ + "img/videocall_white.46ffb8b5.svg";